import {
  TileLayout,
  TileLayoutRepositionEvent,
  Drawer,
  DrawerContent,
  DrawerItem,
  PanelBar,
  PanelBarItem,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import { useSelector } from "react-redux";
import { PDFExport } from "@progress/kendo-react-pdf";
import React, { Fragment, useState, useEffect, PropsWithChildren } from "react";
import { useAppDispatch } from "../../Core/store.hooks";
import { DashboardType } from "../Types/types";
import { AuthApi } from "../../Core/api";
import {
  TabStrip,
  TabStripSelectEventArguments,
  TabStripTab,
} from "@progress/kendo-react-layout";
import { widgetLibrary } from "./widgetLibrary";
import uuid from "react-uuid";
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardActions,
  CardImage,
  CardSubtitle,
  Avatar,
} from "@progress/kendo-react-layout";
import {
  ActionsLayout,
  Window,
  WindowActionsBar,
} from "@progress/kendo-react-dialogs";

import { updateParams, getParamsSelector } from "../Slices/ParamSlice";

interface WidgetSelectionProps {
  currentWidgets: any;
  closeWindow: any;
  addWidgetHandler: any;
  currentStaticContent: any;
}

const WidgetSelection = (props: WidgetSelectionProps) => {
  const [selected, setSelected] = React.useState<number>(0);
  const [widgetList, updateWidgetList] = useState(widgetLibrary);
  const [rowHeight, setRowHeight] = React.useState(90);
  const [colWidth, setColWidth] = React.useState(180);
  const [addedWidgets, updateAddedWidgets] = useState([]);

  const globalParams = useSelector(getParamsSelector);
  const dispatch = useAppDispatch();

    useEffect(() => {
      console.log(props.currentWidgets)
    getWidgetList();
  }, [props.currentWidgets]);

  const getWidgetList = () => {
    const newWidgetList: any = [];
    for (var i = 0; i < widgetLibrary.length; i++) {
      const newWidget = widgetLibrary[i];
      let inUse: boolean = false;
      for (var k = 0; k < props.currentWidgets.length; k++) {
        if (
          props.currentWidgets[k].props.id == widgetLibrary[i].dashboardId 
        ) {
            console.log(props.currentWidgets[k].props.id,widgetLibrary[i].dashboardId)
          inUse = true;
        }
      }
      if (inUse) {
        newWidget.inUse = true;
      } else {
        newWidget.inUse = false;
      }
        if (!newWidget.inUse) newWidgetList.push(newWidget);
        console.log(newWidget, inUse);
    }
      console.log(newWidgetList)
    updateWidgetList(newWidgetList);
  };
  const getUniqGroups = () => {
    let uniqGroups: string[] = [];

    for (let i = 0; i < widgetList.length; i++) {
      if (uniqGroups.indexOf(widgetList[i].group) < 0) {
        uniqGroups.push(widgetList[i].group);
      }
    }
    return uniqGroups;
  };
  const toggleWidget = (w: any) => {
    const newAddedWidgets: any = [];
    let exist: boolean = false;
    for (var i = 0; i < addedWidgets.length; i++) {
      if (addedWidgets[i].dashboardId != widgetList[w].dashboardId) {
        newAddedWidgets.push(addedWidgets[i]);
      } else {
        exist = true;
      }
    }
    if (exist == false) {
      newAddedWidgets.push(widgetList[w]);
    }
    updateAddedWidgets(newAddedWidgets);
  };
  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  };
  const getBGColor = (inUse: boolean) => {
    if (inUse) return "pp-redbg";
    return "";
  };
  const getBorderClass = (w: any) => {
    let isAdded = false;
    for (var i = 0; i < addedWidgets.length; i++) {
      if (addedWidgets[i].dashboardId == widgetList[w].dashboardId) {
        isAdded = true;
        break;
      }
    }
    if (isAdded) return "pp-blueBorder";
    return "";
  };
  const getTabStripContent = () => {
    console.log(globalParams);
    let groupName = "Customer";
    if (globalParams.mainMachineSerialNo != null) {
      groupName = "Machine";
    }
    const list: any = [];
    widgetList.map((w, i) => {
      if (w.group == groupName || w.group == "All") {
        list.push(
          <GridLayoutItem className={`box box-${i}`} key={i}>
            <div onClick={() => toggleWidget(i)} className={getBorderClass(i)}>
              <Card
                style={{
                  width: 172,
                  borderColor: "#ccc",
                  cursor: "pointer",
                }}
              >
                <CardTitle
                  style={{
                    fontSize: "14px",
                    height: "50px",
                    borderBottom: "1px solid #eee",
                    padding: "10px",
                  }}
                >
                  {widgetList[i].label}
                </CardTitle>
                <CardImage
                  src={widgetList[i].imageUrl}
                  style={{
                    height: "120px",
                    width: "180px",
                    padding: "10px 10px",
                  }}
                />
              </Card>
            </div>
          </GridLayoutItem>
        );
      }
    });

    return list;
  };

  const renderGridLayout = () => {
    const gridLayoutContent: any = getTabStripContent();
    if (gridLayoutContent.length < 1) {
      return <div>All available widgets are already on the dashboard.</div>;
    }
    return (
      <GridLayout
        cols={[
          {
            width: colWidth,
          },
          {
            width: colWidth,
          },
          {
            width: colWidth,
          },
          {
            width: colWidth,
          },
          {
            width: colWidth,
          },
        ]}
        gap={{
          rows: 15,
          cols: 15,
        }}
      >
        {gridLayoutContent}
      </GridLayout>
    );
  };
    const addWidgetHandler = () => {
        AuthApi.logUserEvent("Add Widgets");
    props.addWidgetHandler(addedWidgets);
  };
  return (
    <Fragment>
      {renderGridLayout()}

      <WindowActionsBar layout={"stretched"}>
        <button
          type="button"
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
          onClick={() => props.closeWindow()}
          style={{ width: "150px" }}
        >
          Cancel
        </button>
        <button
          type="button"
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
          onClick={() => addWidgetHandler()}
          style={{ width: "150px" }}
        >
          Add Widgets
        </button>
      </WindowActionsBar>
    </Fragment>
  );
};
export default WidgetSelection;
